import axios from "axios";
import { BASE_SPRING_ENDPOINT } from "../../api/config";

export const downloadAccountLedgerInvoice = async (groupId, ledgerId) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Token not present");
  }

  let authToken = token;
  if (token.includes("||master")) {
    authToken = token.replace(/(\|\|master)+$/, "");
  }

  const url = `${BASE_SPRING_ENDPOINT}core/api/v1/account-ledger/download-invoice/${groupId}/${ledgerId}/?groupId=${groupId}&hotelId=${groupId}`;

  const response = await axios.get(url, {
    headers: {
      Authorization: authToken,
    },
    responseType: "blob",
  });

  const blob = new Blob([response.data], { type: "application/pdf" });
  const pdfUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = pdfUrl;
  link.setAttribute("download", `invoice_${ledgerId}.pdf`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(pdfUrl);
};
